export const columns = function () {
  // 统筹单号，机构名称，车牌号，统筹起期，统筹止期，退单日期，应收统筹费（元），净费（元），折扣，应退标准统筹费，应退应交统筹费，应退净费，退单天数（天），退单费用（元），实退金额（元），退单创建时间，财务审核时间，备注
  return [
    {
      prop: "bh",
      label: "统筹单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "统筹起期",
      minWidth: 200,
    },
    {
      prop: "endTime",
      label: "统筹止期",
      minWidth: 200,
    },
    {
      prop: "return_date",
      label: "退单日期",
      minWidth: 100,
    },
    {
      prop: "yjtcfee",
      label: "应收统筹费（元）",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费（元）",
      minWidth: 100,
    },
    {
      prop: "cusRebate",
      label: "折扣",
      minWidth: 100,
    },
    {
      prop: "ytbztcfee",
      label: "应退标准统筹费",
      minWidth: 100,
    },
    {
      prop: "ytyjtcfee",
      label: "应退应交统筹费",
      minWidth: 100,
    },
    {
      prop: "ytnetFee",
      label: "应退净费",
      minWidth: 100,
    },
    {
      prop: "days",
      label: "退单天数（天）",
      minWidth: 100,
    },
    {
      prop: "cost",
      label: "退单费用（元）",
      minWidth: 100,
    },
    {
      prop: "actual_cost",
      label: "实退金额（元）",
      minWidth: 100,
    },
    {
      prop: "create_time",
      label: "退单创建时间",
      minWidth: 200,
    },
    {
      prop: "finance_time",
      label: "财务审核时间",
      minWidth: 200,
    },
    {
      prop: "apply_remark",
      label: "备注",
      minWidth: 150,
    },
  ];
};

export default {};
